export interface TaskUpdatedLike {
  updatedAt?: string | Date | null;
  sourceUpdatedAt?: string | Date | null;
  effectiveLastUpdated?: string | Date | null;
}

function toDateOrNull(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getEffectiveLastUpdated(task: TaskUpdatedLike): Date | null {
  const backendEffective = toDateOrNull(task.effectiveLastUpdated);
  const updatedAt = toDateOrNull(task.updatedAt);
  const sourceUpdatedAt = toDateOrNull(task.sourceUpdatedAt);

  if (backendEffective && updatedAt && sourceUpdatedAt) {
    const computed = updatedAt >= sourceUpdatedAt ? updatedAt : sourceUpdatedAt;
    return backendEffective >= computed ? backendEffective : computed;
  }

  if (updatedAt && sourceUpdatedAt) {
    return updatedAt >= sourceUpdatedAt ? updatedAt : sourceUpdatedAt;
  }

  return backendEffective ?? updatedAt ?? sourceUpdatedAt ?? null;
}
